import React, { createContext, useContext, useState } from 'react';
import uz from './uz';
import ru from './ru';
import en from './en';

const translations = { uz, ru, en };

export const LOCALES = ['uz', 'ru', 'en'];
export const DEFAULT_LOCALE = 'uz';

const I18nContext = createContext({
  locale: DEFAULT_LOCALE,
  setLocale: () => {},
  t: (key) => key,
});

const resolve = (obj, key) => {
  const parts = key.split('.');
  let cur = obj;
  for (const part of parts) {
    if (cur == null || typeof cur !== 'object') return key;
    cur = cur[part];
  }
  return cur != null ? String(cur) : key;
};

export const I18nProvider = ({ children, defaultLocale = DEFAULT_LOCALE }) => {
  const [locale, setLocale] = useState(defaultLocale);

  const t = (key) => resolve(translations[locale] ?? translations[DEFAULT_LOCALE], key);

  return (
    <I18nContext.Provider value={{ locale, setLocale, t }}>
      {children}
    </I18nContext.Provider>
  );
};

export const useI18n = () => useContext(I18nContext);
